export default __webpack_public_path__ + "static/media/1_9.0c9d572d.png";